import moment from 'moment'

const DATE_PATTERN = 'DD-MM-yyyy'
const DATETIME_PATTERN = 'DD-MM-yyyy HH:mm'

export const formatDate = (date) => formatDateByPattern(date, DATE_PATTERN)

export const formatDateTime = (date) => formatDateByPattern(date, DATETIME_PATTERN)

export const formatDateByPattern = (date, pattern = DATETIME_PATTERN) => (date ? moment(date).format(pattern) : '-')

export const parseDate = (date, pattern) => moment(date, pattern).tz('UTC')

export const dateRange = (dates) =>
  dates && {
    from: dates[0]?.startOf('day').format('MM-DD-YYYY'),
    to: dates[1]?.endOf('day').format('MM-DD-YYYY'),
  }
